import { MeetingChatAdapter, useMeetingSelector } from "@kalyzee/kast-web-sdk";
import { useAppStoreSelector } from "../../contexts/appStore/selectors";
import { BoardInputsWorkBox } from "../workBoxes/BoardInputsWorkBox";
import { SurveyWorkBox } from "../workBoxes/survey/SurveyWorkbox";
import { HighlightedUserListWorkBox } from "../workBoxes/list/HighlightedUserListWorkBox";
import { useSdkContext } from "../../contexts/sdk/context";
import { Chatroom } from "@kalyzee/kast-web-sdk/websocket";
import { ChatWorkBox } from "../workBoxes/ChatWorkBox";
import { isExpert } from "../../helpers/roles";
import React, { useRef } from "react";
import Chat, { DashboardChatRef } from "../chat/Chat";
import { useMeetingUtilsContext } from "../../contexts/meetingUtils/context";

export const CurrentWorkBox = React.memo(({
  chatInfo,
}: {
  chatInfo?: {
    room: Chatroom;
    adapter: MeetingChatAdapter | undefined;
},
}) => {
  const { containerAPI, populated } = useMeetingUtilsContext();
  const [session] = useMeetingSelector(containerAPI, "session");

  const sdkCtx = useSdkContext();
  const workBoxMode = useAppStoreSelector(state => state.workBoxMode);

  const chatRef = useRef<DashboardChatRef>(null);

  if (workBoxMode === "none") return null;

  const renderChatWorkBox = () => {
    if (!chatInfo) return null;
    return (
      <ChatWorkBox 
        onClearMessages={isExpert(session) ? () => chatRef.current?.clearMessages() : undefined}
      >
        <Chat 
          meetingAPI={containerAPI}
          chatroom={chatInfo.room}
          chatAdapter={chatInfo.adapter}
          ref={chatRef}
        />
      </ChatWorkBox>
    );
  };

  if (workBoxMode === "inputs") {
    return (
      <div style={{
        flex: 1,
      }}>
        <BoardInputsWorkBox
          meetingAPI={containerAPI}
        />
      </div>
    );
  }
  else if (workBoxMode === "chat") {
    return (
      <div style={{
        flex: 1,
      }}>
        {renderChatWorkBox()}
      </div>
    );
  }
  else if (workBoxMode === "survey") {
    return (
      <div style={{
        flex: 1,
        minWidth: 2,
      }}>
        <SurveyWorkBox meetingAPI={containerAPI} />
      </div>
    );
  }
  else if (workBoxMode === "highlight") {
    return (
      <div style={{
        flex: 1,
      }}>
        <HighlightedUserListWorkBox
          sdk={sdkCtx}
          highlightSessions={populated.highlighted}
        />
      </div>
    );
  }

  return null;
});